import { render } from "./LocatorAttributeForm.vue?vue&type=template&id=7d78f872&ts=true"
import script from "./LocatorAttributeForm.vue?vue&type=script&lang=ts"
export * from "./LocatorAttributeForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__